import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Footer from "./Shared/Footer";
import Image from "./Shared/Image";

const FourZeroFour = () => {
  const { t } = useTranslation();
  return (
    <div className="h-screen flex flex-col">
      <section className="flex-1 px-4 w-full pt-24 pb-12 bg-gradient-to-b from-[#F7DFDF] via-[#FBEFEF88] to-[#ffffff]">
        <div className="w-full max-w-xl mx-auto flex flex-col items-center gap-8">
          <Image src="/assets/404/globe.webp" className="mx-auto w-80" />
          <h2 className="text-center text-2xl font-bold">
            {t("error404.main.title")}
          </h2>
          <p className="text-center font-semibold">
            {t("error404.main.desc1")}
          </p>
          <p className="text-center font-semibold">
            {t("error404.main.desc2")}
          </p>
          <Link
            to="/"
            className="px-10 py-3 mt-4 text-white bg-pr hover:bg-sr transition-all rounded-lg "
          >
            {t("error404.main.button")}
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default FourZeroFour;
